import { ArrayParam, StringParam, NumericArrayParam } from 'use-query-params'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import type { ConnectionsContractorsDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
import type { ColumnTitleSchema } from '@app/types/table'

export const columnTitleMap: ColumnTitleSchema<ConnectionsContractorsDataSource> = {
  monitoringType: 'Тип мониторинга',
  cluster: 'Кластер',
  contractors: 'Подрядчик'
}

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.monitoringTypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.contractorIds]: NumericArrayParam
}

export const tableSearchQuerySchema: TableSearchQuerySchema<ConnectionsContractorsDataSource> = {
  'table-cluster': StringParam,
  'table-contractors': StringParam,
  'table-monitoringType': StringParam
} as const

const titleWrapperProps = { minWidth: 200 } as const

export const columnsSearchSchema: ColumnTableSearchSchema<ConnectionsContractorsDataSource> = {
  cluster: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  contractors: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  monitoringType: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps }
}
